function trackEvent(event, params)
{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
}

export {trackEvent}
